var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"alert-container",attrs:{"ma-0":"","pa-0":"","fluid":""}},[_c('v-layout',{staticClass:"alert-layout align-center",class:_vm.layoutClasses},[_c('v-layout',{class:_vm.stepIndicatorLayoutClass,style:({
        zIndex: _vm.zIndex
      })},[[_c('v-progress-linear',{attrs:{"value":_vm.currentStep/_vm.totalSteps * 100}})]],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }